<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  data: object | string | number
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()

const code = computed(() => props.data || '')
</script>

<template>
  <div class="table-cell code-cell">
    <div class="code-item">{{code}}</div>
  </div>
</template>

<style lang="scss">
.code-cell{
  .code-item{
    background: transparent;
    color: #b800a0;
    padding: 3px 7px;
    border-radius: 4px;
    font-weight: bold;
    font-size: 12px;
    //display: inline-block;
    font-family: "Courier New", Courier, monospace;
    word-break: keep-all;
    white-space: nowrap;
  }
}
</style>
